import { useEffect, useState } from 'react';
import styled from 'styled-components';
import PaymentService from '../../../../service/pay/pay';
import Standard from './standard';
import Premium from './premium';
import { useUser } from '../../../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { isAfterTime } from '../../../../utils/eventTime';

const months = [1, 3, 6, 12];

function PlanPriceGuide() {
  const navigate = useNavigate();
  const { user } = useUser();

  const [selectedMonth, setSelectedMonth] = useState(12);
  const [standardPlans, setStandardPlans] = useState([]);
  const [premiumPlans, setPremiumPlans] = useState([]);

  const idx = Math.max(
    0,
    months.findIndex((o) => o === selectedMonth),
  );

  const getMembershipPlan = async (month: number, type: string) => {
    try {
      const res = await PaymentService.membershipPlan(month, type);
      setStandardPlans(res.data.standard || []);
      setPremiumPlans(res.data.premium || []);
    } catch (error) {
      alert('상품 목록을 불러오는 데 실패했습니다.');
    }
  };

  useEffect(() => {
    getMembershipPlan(selectedMonth, 'A');
  }, [selectedMonth]);

  return (
    <Container>
      <TabContainer>
        <Thumb $index={idx} />
        {months.map((m) => (
          <TabItem
            key={m}
            $active={m === selectedMonth}
            onClick={() => setSelectedMonth(m)}
          >
            {m}개월
          </TabItem>
        ))}
      </TabContainer>
      {standardPlans.length > 0 && (
        <Standard
          month={selectedMonth}
          plans={standardPlans}
          recommend={user?.plan_grade !== 'P' || selectedMonth !== 12}
        />
      )}
      {premiumPlans.length > 0 && (
        <Premium
          month={selectedMonth}
          plans={premiumPlans}
          recommend={user?.plan_grade === 'P'}
        />
      )}

      <Banner
        src="/assets/images/banner/payment-banner-lucky.png"
        alt="banner"
        onClick={() => navigate('/promotion/땅집고옥션-럭키-이벤트')}
      />
    </Container>
  );
}

export default PlanPriceGuide;

const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const TabContainer = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  padding: 4px;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  overflow: hidden;
  background: #f7f7fa;
  user-select: none;
`;

const Thumb = styled.span<{ $index: number }>`
  position: absolute;
  top: 4px;
  left: 4px;
  width: 74px;
  height: calc(100% - 8px);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(141, 149, 163, 0.25);

  transform: ${({ $index }) => `translateX(calc(${$index} * (100% + 4px)))`};
  transition: transform 500ms cubic-bezier(0.25, 0.1, 0.25, 1);
  will-change: transform;
  pointer-events: none;
  z-index: 0;
`;

const TabItem = styled.div<{ $active: boolean }>`
  position: relative;
  z-index: 1;
  flex: 1 0 0;
  width: 74px;
  height: 100%;
  border: 0;
  background: transparent;
  cursor: pointer;

  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  color: ${({ $active }) => ($active ? '#222' : '#37383C9C')};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  line-height: 145%;
  letter-spacing: -0.28px;
  transition: color 160ms ease;
`;

const Banner = styled.img`
  width: 100%;
  aspect-ratio: 328/80;
  border-radius: 16px;
`;
